import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { PrematchSignature } from 'app/constants/matchGridStakes';
import { SsrModule } from 'app/constants/ssrModules';
import { Spinner } from 'app/design-system/components/Spinner';
import { useLocalFeatureFlags } from 'app/lib/feature-flags/useLocalFeatureFlags';
import useComponentWillMount from 'app/lib/hooks/useComponentWillMount';
import { useSSR } from 'app/packages/components/SkipSSR';

import { getPrematchContent } from '../../../Prematch/actions';
import { RootMenu } from '../../components/RootMenu';
import { loading, requested, rootMenuItemsWithPathname } from '../../selectors/prematch';

export const PrematchMenu = () => {
  const isSSR = useSSR();
  const { hasFeatureFlag } = useLocalFeatureFlags();
  const isANTLR = hasFeatureFlag(FeatureFlag.ANTLR);
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const requestedS = useSelector(requested);
  const loadingS = useSelector(loading);
  const params = new URLSearchParams(search);
  const timeFilter = params.get('timeFilter');
  const items = useSelector(rootMenuItemsWithPathname(pathname, timeFilter));

  useComponentWillMount(() => {
    if (isSSR && !requestedS) {
      dispatch(getPrematchContent({
        signature: PrematchSignature.MAIN_LINE_STAKE_SIGNATURE,
        query: { onlyCustomStakeNames: isANTLR },
      }));
    }
  });

  return (
    <>
      {!requestedS && loadingS
        ? <Spinner size={40} />
        : (
          <RootMenu ssrDataId={SsrModule.LEFT_MENU_PREMATCH}
                    list={items} />
        )
      }
    </>
  );
};
